import { makeStyles } from 'tss-react/mui';
import Typography from '../../../../../../../../components/Typography/Typography';
import LangEnum from '../../../../../../../../lang/LangEnum';
import { GetKitCombinationCount } from '../../../../../../../../services/modules/kit/kitDetails/kitDetails.types';
import OrderResume from '../../../../../../../orders/products/section/components/OrderResume';
import { useTranslation } from '../../../../../../../translation/TranslationContext';
import { ClosedKitCombination } from '../../../../../types/kit-combinations.types';

interface KitGroupSectionProps {
  combination: ClosedKitCombination;
  count?: GetKitCombinationCount;
}

const useStyles = makeStyles()(() => ({
  root: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
}));

const KitGroupSection = ({ combination, count }: KitGroupSectionProps) => {
  const { classes } = useStyles();
  const { translate } = useTranslation();
  const customerCommercialNameLabel = combination.customerCommercialName
    ? combination.customerCommercialName
    : translate(LangEnum.ORDER_BOOK_ORDER_WITHOUT_CUSTOMER);

  if (!combination.orderId) {
    return (
      <Typography variant="body2.5-regular" color="textSecondary">
        {translate(LangEnum.ACTIVE_ORDER_NO_ORDER_SELECTED)}
      </Typography>
    );
  }

  const subTotal = count?.subTotal ?? 0;
  const totalItems = count?.totalItems ?? 0;
  const totalPieces = count?.totalPieces ?? 0;

  return (
    <div className={classes.root}>
      <div style={{ display: 'flex', columnGap: '8px' }}>
        <Typography variant="body2.5-regular" color="textSecondary">
          {combination.orderCode}
        </Typography>
        <Typography variant="body2.5-regular" color="textSecondary">
          {customerCommercialNameLabel}
        </Typography>
      </div>

      {count && (
        <OrderResume
          total={subTotal}
          itemsQuantity={totalItems}
          size="small"
          partsQuantity={totalPieces}
        />
      )}
    </div>
  );
};

export default KitGroupSection;
